// reducer.js
import {
  CANDIDATE_BULK_UPLOAD_REQUEST,
  CANDIDATE_BULK_UPLOAD_SUCCESS,
  CANDIDATE_BULK_UPLOAD_FAILURE,
  CANDIDATE_BULK_UPLOAD_RESET,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  status: false,
  message: "",
  upload_outcomes: [],
  parsed_resumes: 0,
};

const candidateBulkUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_BULK_UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CANDIDATE_BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
        upload_outcomes: action.payload.upload_outcomes || [],
        parsed_resumes: action.payload.parsed_resumes ?? 0,
      };
    case CANDIDATE_BULK_UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        message: action.payload?.message || "Upload failed",
        status: false,
      };
    case CANDIDATE_BULK_UPLOAD_RESET:
      return {
        ...state,
        isLoading: false,
        status: false,
        message: "",
        upload_outcomes: [],
        parsed_resumes: 0,
      };
    default:
      return state;
  }
};

export default candidateBulkUploadReducer;
